<script setup lang="ts">
import { AuthMode } from '~/types/interfaces'

const runtimeConfig = useRuntimeConfig()

useSeoMeta({
  title: 'サインイン（パスワード再設定） | Code & Magic',
  description: 'Code & Magicにサインイン（パスワード再設定）',
  ogTitle: 'サインイン（パスワード再設定） | Code & Magic',
  ogDescription: 'Code & Magicにサインイン（パスワード再設定）',
  ogImage: `${runtimeConfig.public.serviceDomain}/images/ogPlayMakeShare_wLogo.webp`,
  twitterCard: 'summary_large_image',
})

definePageMeta({
  layout: 'default',
})
</script>

<template>
  <v-container>
    <Auth :mode="AuthMode.FORGOTPW" />
  </v-container>
</template>
